import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Divider } from 'antd';
import OverviewList from 'components/overviewlist/overview-list';
import { useHistory } from 'react-router';
import { ROUTES } from 'helpers/constants';
import Typography from 'helpers/fonts';
import { useSmallScreen } from 'helpers/isSmallScreen';
import { AnimatedRightArrow } from 'components/animated-arrow/animated-right-arrow';
import { useHover } from 'helpers/useHover';
import './welcome.css';

export interface WelcomeScreenProps {}

const WelcomeScreen: React.FunctionComponent<WelcomeScreenProps> = () => {
  const { t } = useTranslation();
  const isSmallScreen = useSmallScreen();
  const history = useHistory();
  const [hoverRef, isHovered] = useHover();
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: Theme['@grey-lightest'],
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '1 1 auto',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '12px 16px'
        }}
      >
        <Typography styleid={isSmallScreen ? 4 : 1} style={{ margin: isSmallScreen ? '.75rem 0' : '1.75rem 0' }}>
          {t('welcomeScreen.title')}
        </Typography>
        <Divider
          style={{
            width: '78px',
            minWidth: 0,
            borderTop: `4px solid ${Theme['@primary-color']}`,
            margin: '12px 0',
          }}
        />
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: '3.125rem'
          }}
        >
          <OverviewList
            steps={[1, 2, 3, 4, 5].map((step) =>
              t(`welcomeScreen.step${step}`)
            )}
          />
        </div>

        <div
          style={{
            height: isSmallScreen ? 'auto' : '100px',
            width: '100%',
            marginTop: '3.125rem',
            display: 'flex',
            justifyContent: 'center',
            position: isSmallScreen ? 'fixed' : 'initial',
            bottom: 0,
          }}
        >
          <Button
            style={{
              justifySelf: 'flex-end',
              margin: isSmallScreen ? 0 : '12px 0px',
              // marginBottom: isSmallScreen ? '40px' : '57px',
              height: isSmallScreen ? 39 : 53,
              // lineHeight: isSmallScreen ? '39px' : '53px',
              display: 'flex',
              width: isSmallScreen ? '100%' : '240px',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
            className="next-button"
            ref={hoverRef}
            type="primary"
            size="large"
            block={isSmallScreen}
            onClick={() => {
              history.push(ROUTES.PRODUCTS_SCREEN);
            }}
          >
            <Typography
              style={{
                color: 'white',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                fontFamily: 'Gibson Medium',
                // margin: "2px"
              }}
              styleid={isSmallScreen ? 6 : 4}
            >
              {t('welcomeScreen.getStarted')}
              <div style={{ width: '20px', height: '23px' }}>
                <AnimatedRightArrow hovered={isHovered} />
              </div>
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
